(() => {
  const selector = '.elevia-landing > header, .ed > .ed-header';
  let previous = Math.max(0, window.scrollY);
  let distance = 0;
  let scheduled = false;

  function update() {
    scheduled = false;
    const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const current = Math.min(maximum, Math.max(0, window.scrollY));
    const delta = current - previous;
    previous = current;
    const header = document.querySelector(selector);
    if (!header) return;

    const menuOpen = header.querySelector('details[open], [aria-expanded="true"]');
    if (current <= header.offsetHeight + 40 || menuOpen || header.querySelector(':focus-visible')) {
      header.classList.remove('elevia-header-hidden');
      distance = 0;
      return;
    }

    if (delta === 0) return;
    distance = Math.sign(delta) === Math.sign(distance) ? distance + delta : delta;
    if (Math.abs(distance) < 8) return;
    header.classList.toggle('elevia-header-hidden', distance > 0);
    distance = 0;
  }

  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }, {passive: true});

  document.addEventListener('focusin', event => {
    const header = event.target.closest(selector);
    if (header) header.classList.remove('elevia-header-hidden');
  });

  window.addEventListener('pageshow', () => {
    previous = Math.max(0, window.scrollY);
    distance = 0;
    document.querySelector(selector)?.classList.remove('elevia-header-hidden');
  });
})();
